import { getStoredTokenData } from "@risalabs_frontend_org/auth-wrapper";
import { API_ENDPOINTS } from "../../enums/apiUrls";

export interface UpdateProfilePayload {
  id: string;
  FirstName?: string;
  LastName?: string;
  ProfilePicUrl?: string;
}

export interface UpdateProfileResponse {
  success: boolean;
  message?: string;
  data?: any;
}

/**
 * Makes a POST call to update user profile
 * @param payload - The profile update payload
 * @returns Promise<UpdateProfileResponse>
 */
export const updateProfile = async (
  payload: UpdateProfilePayload,
): Promise<UpdateProfileResponse> => {
  try {
    const token = getStoredTokenData()?.token;

    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.UPDATE_PROFILE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      return {
        success: false,
        message: errorData?.detail || response.statusText,
      };
    }

    const responseData = await response.json();

    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};
